export function isHelpDeskTicket(ticket) {
  return 'ticket' in ticket && ticket.ticket.objectTypeId === '0-5';
}